import { z } from 'zod'

export const PexelVideo = z.object({
  id: z.number(),
  name: z.string(),
  alt: z.string(),
  type: z.enum(['video']),
  tags: z.array(z.object({ type: z.enum(['search']), title: z.string() })),
  thumbnail: z.string(),
  downloadLink: z.string(),
})

export type PexelVideo = z.infer<typeof PexelVideo>;